module.exports = __webpack_public_path__ + "static/img/bg-fr.41655635.webp";